// src/screens/VuelosGuyanaPublicScreen.jsx
// Réplica pública (sin login) de VuelosGuyanaScreen, servida en
// app.clicktravelagency.com.br/vuelos-guyana. No hay user.uid disponible,
// así que el flujo compartido no registra vuelos_cotizaciones aquí -- no
// hay usuario ni referido posible que trackear en esta versión.
import React, { useState, useEffect } from 'react';
import { openWhatsApp } from '../services/authService';
import { logVuelosEvento, construirSaludoWhatsapp, getGestorActivoCodigo } from '../services/vuelosGuyanaService';
import VuelosGuyanaFlow from './vuelosGuyana/VuelosGuyanaFlow';
import TarjetaResenasClientes from '../components/TarjetaResenasClientes';
import { GRUPO_WHATSAPP_URL } from '../config/links';

const SOCIALS = [
  { icon: '📘', label: 'Facebook', url: 'https://www.facebook.com/share/193v7eZgzH/' },
  { icon: '🎵', label: 'TikTok', url: 'https://tiktok.com/@clicktravelagency' },
  { icon: '📸', label: 'Instagram', url: 'https://www.instagram.com/clicktravelagencyes' },
  { icon: '🌐', label: 'Sitio web', url: 'https://clicktravelagency.com.br/' },
];

function Header() {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: 'var(--bg)', borderBottom: '1px solid var(--navy-border)',
      backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
      padding: '14px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src="/logo-principal.png" alt="Click Travel Agency" style={{ width: 34, height: 34, borderRadius: 8, objectFit: 'cover' }} />
        <span style={{ fontSize: 15, fontWeight: 800, color: 'var(--white)' }}>Click Travel Agency</span>
      </div>
      <button onClick={() => {
        logVuelosEvento('clic_whatsapp', { origen: 'publico' });
        openWhatsApp(construirSaludoWhatsapp('Necesito más información sobre ', 'publico'));
      }} style={{
        background: 'rgba(0,196,140,0.15)', border: '1px solid rgba(0,196,140,0.4)',
        color: 'var(--success)', fontWeight: 700, fontSize: 12, borderRadius: 20, padding: '8px 14px',
        display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
      }}>💬 WhatsApp</button>
    </div>
  );
}

function BotonSitioWeb() {
  return (
    <a href="https://clicktravelagency.com.br/" target="_blank" rel="noopener noreferrer"
      onClick={() => logVuelosEvento('clic_sitio_web', { origen: 'publico' })} style={{
      display: 'flex', alignItems: 'center', gap: 12, textDecoration: 'none',
      margin: '12px 16px 0', padding: '14px', borderRadius: 14,
      background: 'linear-gradient(135deg, rgba(255,107,0,0.14), rgba(0,196,140,0.08))',
      border: '1px solid rgba(255,107,0,0.35)',
    }}>
      <span aria-hidden="true" style={{
        flex: 'none', width: 40, height: 40, borderRadius: 11, background: 'rgba(255,107,0,0.18)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18,
      }}>🌐</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 13.5, fontWeight: 800, color: 'var(--white)', lineHeight: 1.3 }}>
          Cotiza vuelos y hoteles en Brasil en tiempo real
        </span>
        <span style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginTop: 3 }}>
          Entra a nuestro sitio web y compara al instante
        </span>
      </span>
      <span style={{
        flex: 'none', background: 'var(--orange)', color: 'var(--navy)', fontSize: 11, fontWeight: 800,
        borderRadius: 8, padding: '8px 12px', whiteSpace: 'nowrap',
      }}>Visitar</span>
    </a>
  );
}

function QuienesSomos() {
  return (
    <div style={{
      margin: '14px 16px 0', padding: '16px', borderRadius: 14,
      background: 'var(--navy-card)', border: '1px solid var(--navy-border)',
      borderLeft: '3px solid var(--orange)',
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
      display: 'flex', gap: 12, alignItems: 'flex-start',
    }}>
      <span aria-hidden="true" style={{
        flex: 'none', width: 34, height: 34, borderRadius: 10,
        background: 'rgba(255,107,0,0.14)', display: 'flex', alignItems: 'center',
        justifyContent: 'center', fontSize: 17,
      }}>🛡️</span>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
          <p style={{ margin: 0, fontSize: 14, fontWeight: 800, color: 'var(--white)' }}>
            Registro Oficial CADASTUR
          </p>
          <span style={{
            fontSize: 10.5, fontWeight: 700, letterSpacing: '0.03em', color: 'var(--success)',
            background: 'rgba(0,196,140,0.14)', border: '1px solid rgba(0,196,140,0.3)',
            borderRadius: 999, padding: '2px 8px', whiteSpace: 'nowrap',
          }}>N.º 61.388.173/0001-13</span>
        </div>
        <p style={{ margin: 0, fontSize: 13, lineHeight: 1.55, color: 'var(--muted)' }}>
          Agencia de Turismo activa y registrada en Brasil.
        </p>
      </div>
    </div>
  );
}

// Mismo mecanismo real de instalación que InstallBanner (App.jsx) -- acá se
// captura aparte porque esta pantalla pública se sirve antes que cualquier
// gate de autenticación (App.jsx retorna VuelosGuyanaPublicScreen sin pasar
// por AuthProvider/InstallBanner), así que no hay dónde reusar ese estado.
function useInstallPrompt() {
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    const handler = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (prompt) {
      await prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
    } else {
      // Sin evento capturado (ya instalada, iOS, o el navegador todavía no
      // lo disparó): igual lleva a la app para que el usuario la agregue a
      // inicio desde el propio menú del navegador.
      window.location.href = 'https://app.clicktravelagency.com.br/';
    }
  };

  return instalar;
}

function Footer() {
  const instalar = useInstallPrompt();
  // Quien llegó por el link de un gestor no ve el grupo: el grupo no deja
  // rastrear de quién vino cada persona, así que lo justo para el gestor es
  // que esa visita escriba por WhatsApp directo (queda registrada a su
  // nombre). Ya después Yoedis les pasa el link del grupo por chat.
  const conGestor = !!getGestorActivoCodigo();

  return (
    <div style={{ padding: '0 16px 40px' }}>
      <p style={{ margin: '0 0 8px', fontSize: 9.5, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: 'var(--muted)', textAlign: 'center' }}>
        Nuestras redes
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 20, marginBottom: 14 }}>
        {SOCIALS.map((s) => (
          <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, textDecoration: 'none',
          }}>
            <span style={{
              width: 34, height: 34, borderRadius: 10, background: 'var(--navy-card)',
              border: '1px solid var(--navy-border)', display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: 15,
            }}>{s.icon}</span>
            <span style={{ fontSize: 9, color: 'var(--muted)' }}>{s.label}</span>
          </a>
        ))}
      </div>

      {!conGestor && (
      <a href={GRUPO_WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
        onClick={() => logVuelosEvento('clic_whatsapp', { origen: 'publico' })} style={{
        display: 'flex', alignItems: 'center', gap: 11, textAlign: 'left', textDecoration: 'none',
        background: 'rgba(0,196,140,0.10)', border: '1px solid rgba(0,196,140,0.3)',
        borderRadius: 13, padding: '11px 13px', marginBottom: 8,
      }}>
        <span aria-hidden="true" style={{
          flex: 'none', width: 30, height: 30, borderRadius: 10, background: 'rgba(0,196,140,0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15,
        }}>💬</span>
        <span style={{ flex: 1 }}>
          <span style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: 'var(--success)' }}>
            Grupo de WhatsApp
          </span>
          <span style={{ display: 'block', fontSize: 10.5, color: 'var(--muted)', marginTop: 1, lineHeight: 1.3 }}>
            Información, servicios y atención directa.
          </span>
        </span>
        <span style={{
          flex: 'none', background: 'var(--success)', color: 'var(--navy)', fontSize: 10.5, fontWeight: 700,
          borderRadius: 8, padding: '7px 10px', whiteSpace: 'nowrap',
        }}>Entrar</span>
      </a>
      )}

      <button onClick={instalar} style={{
        display: 'flex', alignItems: 'center', gap: 11, textAlign: 'left', width: '100%',
        background: 'rgba(255,107,0,0.08)', border: '1px solid rgba(255,107,0,0.3)',
        borderRadius: 13, padding: '11px 13px',
      }}>
        <span aria-hidden="true" style={{
          flex: 'none', width: 30, height: 30, borderRadius: 10, background: 'rgba(255,107,0,0.18)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15,
        }}>📱</span>
        <span style={{ flex: 1 }}>
          <span style={{ display: 'block', fontSize: 12.5, fontWeight: 700, color: 'var(--orange)' }}>
            App Click Travel Agency
          </span>
          <span style={{ display: 'block', fontSize: 10.5, color: 'var(--muted)', marginTop: 1, lineHeight: 1.3 }}>
            Consulta vuelos y servicios cuando quieras.
          </span>
        </span>
        <span style={{
          flex: 'none', background: 'var(--orange)', color: 'var(--navy)', fontSize: 10.5, fontWeight: 700,
          borderRadius: 8, padding: '7px 10px', whiteSpace: 'nowrap',
        }}>Instalar</span>
      </button>
    </div>
  );
}

export default function VuelosGuyanaPublicScreen() {
  // El footer (redes/grupo/app) solo tiene sentido en el selector de
  // destino -- una vez adentro del embudo (ciudad, fechas, reservar) no
  // debe competir con la acción principal. VuelosGuyanaFlow avisa en qué
  // nivel está vía onNivelChange.
  const [nivel, setNivel] = useState('inicio');

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Header />
      <div style={{ maxWidth: 480, margin: '0 auto' }}>
        <QuienesSomos />
        <BotonSitioWeb />
        <TarjetaResenasClientes destino="/nuestros-clientes" />
        <VuelosGuyanaFlow uid={null} referredBy={null} origen="publico" onNivelChange={setNivel} />
        {nivel === 'inicio' && <Footer />}
      </div>
    </div>
  );
}
